import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BreakpointService } from '@servicios/breakpoint.service';
import { ConfigService } from '@servicios/config.service';
import { PatientService } from '@servicios/patient/patient.service';
import { emailIsValid, passwordCoinciden, showFormControl, phoneIsValid } from 'app/_sharedFuctions/shared-functions';
import { AddressInput, GetCitiesQuery_getAllCities, GetStateQuery_getAllStates, GetTechnicalConfigQuery_techConfigs } from '@modelos/interfaces/operation-result-types';
import { AdminConfigService } from '@servicios/adminConfig.service';
import { forkJoin } from 'rxjs';
import { AuthenticationService } from '@servicios/authentication.service';
import { getErrorMessage } from '../../_helpers/getErrorMessage';
import { Router } from '@angular/router';
import { LoadOptionsService } from '@servicios/load_options/load_options.service';
import { PatientAppInput } from '@interfaces/operation-result-types';

import { HttpResponseBase } from '@angular/common/http';
import { MessageService } from 'primeng/api';


export class PatientInputClass implements PatientAppInput  {   
  name: string;
  lastName: string;
  dni: string;
  affiliateNumber?: string;
  birthdate?: any;
  socialWork: string;
  v_?: number;
  resultEmails?: string[];
  invoiceEmails?: string[];
  phones?: string[];
  address?: AddressInput; 

  constructor(data: any) {    
    this.name = data.name,
    this.lastName = data.lastName,
    this.dni = data.dni,
    this.affiliateNumber = data.affiliateNumber,
    this.birthdate = data.birthdate,
    this.socialWork = data.socialWork,   
    this.v_ = data.v_,
    this.resultEmails = data.resultEmails,
    this.invoiceEmails = data.invoiceEmails,
    this.phones = data.phones,
    this.address = data.address         
  }
}
export class CredentialsClass { 

  password: string;
  user?: string;
  name?: string; 
  email?: string;
  v_?: number;

  constructor(data: any) {
    this.name = data.name,
    this.password = data.password,
    this.user = data.user || data.dni,   
    this.v_ = data.v_,
    this.email = data.email         
  }
  
}


@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss',
    standalone: false
})

export class RegisterComponent implements OnInit {  


  constructor(  
    private messageService: MessageService,
    private fb: UntypedFormBuilder,
    public cs: ConfigService,
    public bs: BreakpointService,
    public ps: PatientService,    
    private acs: AdminConfigService,    
    public auth: AuthenticationService,
    private router: Router,
    public opts: LoadOptionsService
  ) {}

  isLoading = false
  hide = true
  demo = false
  ckechRoute = true;
  maxDate = new Date();
  loadingAddressCities = false
  addressControls: { [key: string]: AbstractControl; };
  formControls: { [key: string]: AbstractControl; };
  form: UntypedFormGroup
  getErrorMessage = getErrorMessage;

  formCodeVisible = signal(false);
  resendCode = signal(false); 
  disabledButton = signal(false);
  validationEmailSignal = signal(false);

  filterSocialWorkBy = new UntypedFormControl('')
  filteredSocialWork: WritableSignal<GetTechnicalConfigQuery_techConfigs[]> = signal([])
  patient_socialWorkSG= {
    name: 'patient_socialWorkSG',
    filteredValues: this.filteredSocialWork,
    params: ['socialWorks']
  }

  filterStatesBy = new UntypedFormControl('')
  filteredStates: WritableSignal<GetStateQuery_getAllStates[]> = signal([])
  statesOptsSG= {
    name: 'statesOptsSG',
    filteredValues: this.filteredStates
  }

  filterCitiesBy = new UntypedFormControl('')
  filteredCities: WritableSignal<GetCitiesQuery_getAllCities[]> = signal([])
  citiesOptsSG= {
    name: 'citiesOptsSG',
    filteredValues: this.filteredCities
  }

  opts_required = [
    this.patient_socialWorkSG,
    this.statesOptsSG,
    this.citiesOptsSG
  ]  
 

  text = '';

  

  ngOnInit(): void {

    this.form = this.fb.group({
      user: [''],
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      dni: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      code: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
      birthdate: [],      
      affiliateNumber: [''],
      socialWork: [null, Validators.required], 
  
      resultEmails: [[]],
      invoiceEmails:[[]],
      phones: [[]],
      address: this.fb.group({
        address: [],        
        state: [],
        city: []
      }),
      website: ['']
    })

    this.formControls = this.form.controls;
    this.addressControls = (this.form.controls.address as UntypedFormGroup).controls


    this.form.setValidators(passwordCoinciden('password', 'confirmPassword', this));
    this.form.updateValueAndValidity({ emitEvent: false })
    
     //Subscripcions
     let optsToLoad= this.opts.loadOptions(this.opts_required)

     forkJoin(optsToLoad).subscribe({
       error: err => { console.error(err), this.isLoading = false },
       complete:  () => {       
                 
         this.isLoading = false
       }
     })

  
  }

  clientRegister() {    
    let data = new PatientInputClass(this.form.value)
    let credentials = new CredentialsClass(this.form.value)
   
    try{
      this.auth.RegisterPatient(data, credentials, this.form.value.code)
      .subscribe({
        next: ({ data: { createPatientFromApp: {succeded, errors} } }) => {           
            if(succeded && !errors) {
              this.toLogin()
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Registrado correctamente', key: 'global' });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'El dni o el email son incorrectos o ya estan en uso.', key: 'global' });
            }

            this.isLoading = false;
          },
          error: err => {            
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, key: 'global' });
            this.isLoading = false;
          } 
        }) 
    } catch (err) {
      this.isLoading = false;
      return this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, key: 'global' });
    }    
  }

  
  checkShowControl(form:string, control: string){
    return showFormControl(form, control, undefined, this.cs.appSettings, undefined, false)
  }


  stateGroupValueChanged($event,loadingSpinner: string, filteredCities: string, formGroup: string) {
    this.loadingAddressCities = true
    this[loadingSpinner] = true
    let stateId = $event?.value     
    let state = this.filteredStates().find(state => state.id == stateId)
    if(!state) return this[loadingSpinner] = false
    this.acs.getCities(state?.countryId, state.code).subscribe({
      next: ({data:{getAllCities}}) => {        
        this.filteredCities.update(()=> getAllCities);
        (this.formControls[formGroup] as UntypedFormGroup).controls.city.reset()
        this[loadingSpinner] = false
        this.loadingAddressCities = false        
      }      
    })
  }

  clearCity() {
    (this.formControls['address'] as UntypedFormGroup).controls.city.reset()
  }

  disableCitySelect(formGroup: string){
    return (this.formControls[formGroup] as UntypedFormGroup).controls.state.value == undefined
  }

    /* UI Helpers */
    phoneIsValid = phoneIsValid;
    emailIsValid = emailIsValid;

  toLogin(){     
    this.form.reset()
    this.router.navigateByUrl('/loginClient')
  }

  save() {
    this.isLoading = true;
    if (this.form.value.website) {
      // Honeypot alert: simulated success
      this.toLogin()
      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Registrado correctamente', key: 'global' });
      this.isLoading = false;
      return;
    }
    this.clientRegister()
  }

  nameButton() {
    return this.formCodeVisible() ? 'Reenviar Código' : 'Validar Mail'
  }

  disabledButtonCode() {
    if(this.formCodeVisible()){
      if(!this.form.value.code || !this.resendCode()) return true
    } else {
      if(this.validationEmailSignal() || !this.form.value.email  || this.isLoading) return true
    }    
    return false
  }

  validationMail(resetCode = false) {
    this.isLoading = true;
    try {
      this.auth.sendValidationMail(this.form.value.user, this.form.value.email, this.form.value.dni.toString())
      .subscribe({
        next: ({ data: {sendValidationMail}  }) => {            
            this.resendCode.update(()=> false);  
            this.validationEmailSignal.update(()=> true)
            this.counterCode()         
            if(this.formCodeVisible()) return           
            this.formCodeVisible.update(()=> !this.formCodeVisible());
          },
          error: err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, key: 'global' });
            console.log(err)          
          } 
        }) 
      this.isLoading = false;
    } catch (err) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, key: 'global' });
      console.log(err)
      this.isLoading = false;
    }    
  }

  counterCode() {    
    setTimeout(() => {
      this.resendCode.update(()=> true);      
    }, 300000);  
    this.disabledButton.update(()=> false); 
  }  
 

}
